export enum LoginStep {
  LOGIN = 0,
  VALIDATE_PHONE = 1,
  LOGIN_EMAIL = 2,
  VALIDATE_EMAIL = 3,
  PASSWORD_LOGIN = 4,
  FORGET_PASSWORD = 5,
}

export const loginStepGroupBuying = {
  LOGIN_EMAIL: 0,
  VALIDATE_EMAIL: 1,
} as const

export enum PasswordSuccessType {
  REGISTER = 0,
  CHANGE = 1,
}

export enum BindStep {
  INPUT_ACCOUNT = 0,
  VALIDATE = 1,
}

export interface SpecialLoginParams {
  isSpecialLogin: boolean
  orderId: string
}
